<template>
  <div v-if="review" class="card-review">
    <div class="stars-wrapper">
      <span
        v-for="i in 5"
        :key="`star-${i}`"
        class="star-item"
        :style="getStarStyle(i, review.score)"
      >
        ★
      </span>
    </div>

    <span v-if="review.score" class="review-text">
      {{ review.score.toFixed(1) }}
      <small>
        ({{ $tc('reviews', review.count, { count: review.count }) }})
      </small>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Review',

  props: {
    review: {
      type: Object,
      default: () => ({
        score: 0,
        count: 0,
      }),
    },
  },

  methods: {
    /**
     * @param {number} starIndex
     * @param {number} score
     * @returns {object}
     */
    getStarStyle(starIndex, score) {
      const relativeScore = score - (starIndex - 1)
      const fillPercentage = Math.max(0, Math.min(100, relativeScore * 100))

      const fillColor = '#FF9529'
      const emptyColor = '#F3F4F6'

      return {
        background: `linear-gradient(to right, ${fillColor} ${fillPercentage}%, ${emptyColor} ${fillPercentage}%)`,
        '-webkit-background-clip': 'text',
        'background-clip': 'text',
        color: 'transparent',
      }
    },
  },
}
</script>

<i18n>
{
  "nl": {
    "reviews": "Geen beoordelingen | {count} beoordeling | {count} beoordelingen"
  },
  "nl-BE": {
    "reviews": "Geen beoordelingen | {count} beoordeling | {count} beoordelingen"
  },
  "es-ES": {
    "reviews": "Sin reseñas | {count} reseña | {count} reseñas"
  },
  "de-DE": {
    "reviews": "Keine Bewertungen | {count} Bewertung | {count} Bewertungen"
  },
  "fr-BE": {
    "reviews": "Aucun avis | {count} avis | {count} avis"
  },
  "fr-FR": {
    "reviews": "Aucun avis | {count} avis | {count} avis"
  },
  "it-IT": {
    "reviews": "Nessuna recensione | {count} recensione | {count} recensioni"
  }
}
</i18n>
